export default __webpack_public_path__ + "static/media/Bb_major.140787d5.jpg";